export { useClinics } from './useClinics';
